import { Component, OnInit, inject} from '@angular/core';
import { Router } from '@angular/router';
import { faLocationQuestion } from '@fortawesome/pro-light-svg-icons';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import Keycloak from 'keycloak-js';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    imports: [FaIconComponent],
})
export class PageNotFoundComponent implements OnInit {
  private readonly keycloak = inject(Keycloak);
  private readonly router = inject(Router);

  locationQuestionIcon = faLocationQuestion;

  constructor() { }

  ngOnInit() {
  }

  hasHomeAccess(): boolean {
    const parsed = this.keycloak.tokenParsed as any;
    return parsed.realm_access?.roles?.includes('home:full');
  }

  redirectToHome() {
    this.router.navigate(['/core/home']);
  }

}
